import { render, staticRenderFns } from "./BeeTabs.vue?vue&type=template&id=24f84bec&scoped=true&"
import script from "./BeeTabs.vue?vue&type=script&lang=js&"
export * from "./BeeTabs.vue?vue&type=script&lang=js&"
import style0 from "./BeeTabs.vue?vue&type=style&index=0&id=24f84bec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f84bec",
  null
  
)

export default component.exports